<template>
  <div class="aboutPage">
    <div class="jojo_about">
      <div>
        <div>What is WorldKey?</div>
        <div>
          <p class="sub_title">About WorldKey</p>
          <p>WorldKey is a cutting-edge 3D data platform providing high-quality, real-world spatial data for AI, robotics, and autonomous systems.</p>
          
          <p class="sub_title">Mission and Vision</p>
          <p>Our mission is to empower the next generation of intelligent systems by providing scalable, high-quality 3D data that bridges the gap between the physical and digital worlds. We are building the data infrastructure that will shape the future of AI and robotics.</p>
          
          <p class="sub_title">Partnerships and Collaborations</p>
          <p>Through strategic partnerships with NVIDIA, Microsoft, and AWS, we are contributing to innovation in industries that rely on real-world data.</p>
          
          <p class="sub_title">Our Team</p>
          <p>Built by a team from Stanford, Harvard, and Columbia, with prior experience at Meta, YouTube, JPMorgan, and TikTok, WorldKey combines top-tier research and real-world execution to power the next generation of Physical AI.</p>
          
          <p class="sub_title">Join Us</p>
          <p>Join us in shaping the future of AI and robotics.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'About',
  data () {
    return {
    }
  },
  mounted () {
  },
  components: {
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">

@media (max-width: 767px) {

 .jojo_about {
   background:url("../assets/H5_about_bg.png");
   position:absolute;
   top:0px;
   width:100%;
   height:100%;
   overflow-y:auto;
   >div:nth-child(1) {
      padding:95px 10% 42px;
      >div:nth-child(1) {
        color: #FFF;
        text-align: center;
        text-shadow: 0px 1.54px 3px rgba(0, 0, 0, 0.30);
        font-size: 22px;
        font-style: normal;
        font-weight: 700;
        line-height: 128%;
      }
      >div:nth-child(2) {
        p {
          margin-top:12px;
          color: #E5E5E5;
          text-align: left;
          text-shadow: 0px 1.54px 3px rgba(0, 0, 0, 0.30);
          font-size: 13px;
          font-style: normal;
          font-weight: 500;
          line-height: 22px;
        }
        .sub_title {
          font-weight: 700;
          color: #FFF;
          margin-top: 24px;
          margin-bottom: 4px;
        }
      }
   }
 }
}
@media (min-width: 767px) {
  .aboutPage {
     width:100%;
       height:calc(~"100% - 135px");
      background:url("../assets/web_bg1.png") no-repeat;
      background-position: center;
      position: relative;
      overflow-y: auto;
  }
  .jojo_about {
    width:770px;
    margin:auto;
    z-index:2;
    padding-bottom: 50px;
    >div:nth-child(1) {
      margin-top:20px;

      >div:nth-child(1) {
      font-family: "EncodeSans-Bold";
        font-size: 24px;
        line-height: 34px;
        color: #FFFFFF;
        text-align: center;
        padding-top:40px;
      }
      >div:nth-child(2) {
        font-size:15px;
        margin-top:20px;
        p {
          margin-top:0;
          margin-bottom:20px;
          font-size: 18px;
          line-height: 28px;
          text-align: left;
        }
        .sub_title {
          font-weight: bold;
          margin-bottom: 5px;
        }
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/About.vue